/**
 * GERADO PELO CI — não editar à mão.
 * Ver .gitlab/scripts/gerar-build-info.sh e SENTRY.md.
 */
export const BUILD_INFO = {
  release: '49db57b9',
  dist: 'production',
};
